import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { HomeContentWidget } from "./home-content-widget.model";

const ACTION_PREFIX = "[Home Content Widget]";
export const HOME_CONTENT_WIDGET_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get Content`,
	getSuccess: `${ACTION_PREFIX} Fetch Content Success`,
	getFail: `${ACTION_PREFIX} Fetch Content Fail`,
};

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(ContentServiceCommand.GetHomeContentWidget) instead
 */
export class HomeContentWidgetAction {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(ContentServiceCommand.GetHomeContentWidget) instead
	 */
	get(): Action {
		return {
			type: HOME_CONTENT_WIDGET_ACTION_TYPE.get,
		};
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(ContentServiceCommand.GetHomeContentWidget) instead
	 */
	getSuccess(payload: HomeContentWidget[]): ActionWithPayload {
		return {
			type: HOME_CONTENT_WIDGET_ACTION_TYPE.getSuccess,
			payload,
		};
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(ContentServiceCommand.GetHomeContentWidget) instead
	 */
	getFail(error: AppError): ActionWithPayload {
		return {
			type: HOME_CONTENT_WIDGET_ACTION_TYPE.getFail,
			payload: error,
		};
	}
}
